import { normalizeObject } from './normalizeObject';
export const checkValueEmpty = (candidate) => {
    if (candidate instanceof Date) {
        return isNaN(candidate.getTime());
    }
    if (candidate && typeof candidate === 'object' && !Array.isArray(candidate)) {
        return Object.values(normalizeObject(candidate)).length === 0;
    }
    if (Array.isArray(candidate)) {
        return candidate.length === 0;
    }
    if (typeof candidate === 'string') {
        return candidate.trim() === '';
    }
    return candidate === null || candidate === undefined;
};
